import * as React from 'react';
import AscParticipationTab from 'components/ExpertTabs/AscParticipationTab/AscParticipationTab';
import { IRootState } from '../../redux/store/configureStore';
import { connect } from 'react-redux';

const AscParticipateContainer: React.FC<IProps> = props => (
  <AscParticipationTab
    title="Участие в комиссиях"
    category="Список всех комиссий и статусов"
    linkedExpertStatusesDetails={props.linkedExpertStatusesDetails || []}
  />
);

const mapStateToProps = (state: IRootState) => ({
    linkedExpertStatusesDetails: state.auth.auth ? state.auth.auth.profile.linkedExpertStatusesDetails : null,
});

type ConnectedProps = ReturnType<typeof mapStateToProps>;
type IProps = ConnectedProps;

export default connect(mapStateToProps)(AscParticipateContainer);
